import { api } from '@/api/core';
import { mockDelay } from './mockUtils';

export interface DownloadProjectFilesRequest {
  projectId: string;
  fileIds: string[];
}

const MOCK_RESPONSE_DELAY_MS = 800;

const downloadProjectFilesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    downloadProjectFiles: builder.mutation<void, DownloadProjectFilesRequest>({
      // The backend has no project file storage yet, so there is nothing to download.
      queryFn: async () => {
        await mockDelay(MOCK_RESPONSE_DELAY_MS);
        return { data: undefined };
      },
    }),
  }),
});

export const { useDownloadProjectFilesMutation } = downloadProjectFilesApi;
